export interface IWheelStatistics {
  visible: boolean;
  onShowHistory: (value: boolean) => void;
}

export enum WheelHistoryType {
  my = 'My',
  recent = 'Recent',
}
